var map = {
	"./decor-icons.js": 1305,
	"./internal-page-header-decor.js": 4507,
	"./js-columns-animation.js": 4879,
	"./js-tabs.js": 7288,
	"./js-text-block.js": 250,
	"./key-numbers.js": 6485,
	"./move-button-on-mobile-js.js": 2955,
	"./scheme.js": 7161,
	"./section-title.js": 1416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6090;